export const zeroPad = num => num.toString().padStart(2, '0');